export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11849.2c14f8a1.jpg";